import React from 'react';

import { SDK_CLASS_NAMES } from '@/features/method-tester/constants';
import {
  ClassNameOption,
  UseSDKMethodFormReturn,
} from '@/features/method-tester/types/formTypes';
import { isGPMotion } from '@/utils';
import { Dropdown } from '@asphalt-react/selection';
import { Textfield } from '@asphalt-react/textfield';
import { Text } from '@asphalt-react/typography';

interface ClassMethodFormProps {
  formData: UseSDKMethodFormReturn;
  gpMotionMethods?: string[];
}

const ClassMethodForm: React.FC<ClassMethodFormProps> = ({
  formData,
  gpMotionMethods,
}) => {
  const { formState, updateField } = formData;
  const { className, methodName } = formState.data;

  const handleMethodNameChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    updateField('methodName', event.target.value);
  };

  const handleClassChangeAndResetMethod = (selectedOption: ClassNameOption) => {
    updateField('className', selectedOption.key);
    // Optionally reset methodName when class changes
    updateField('methodName', '');
  };

  const dropdownItems = SDK_CLASS_NAMES.map((item) => ({
    ...item,
    initialSelected: item.key === className,
  }));

  return (
    <div className="mb-4 space-y-4">
      <label htmlFor="class-dropdown">
        <Text size="s">Class Name:</Text>
      </label>
      <Dropdown
        key={`dropdown-${className || 'empty'}`}
        id="class-dropdown"
        items={dropdownItems}
        onChange={handleClassChangeAndResetMethod}
        placeholder="Select class name"
        stretch={true}
        typeahead
        size="s"
      />

      <label htmlFor="method-name-input">
        <Text size="s">Method Name:</Text>
      </label>
      {isGPMotion(className) && gpMotionMethods ? (
        <Dropdown
          key={`gp-motion-method-dropdown-${className || 'empty'}`}
          id="method-name-input"
          items={[
            ...gpMotionMethods.map((method) => ({
              key: method,
              id: method,
            })),
          ]}
          value={methodName}
          onChange={(selected) => {
            updateField('methodName', selected.key);
          }}
          placeholder="Select method"
          stretch={true}
          size="s"
        />
      ) : (
        <Textfield
          id="method-name-input"
          type="text"
          value={methodName}
          onChange={handleMethodNameChange}
          placeholder="Enter method name"
          stretch={true}
          size="s"
        />
      )}
    </div>
  );
};

export default ClassMethodForm;
